<div id="head"></div>

<!-- The top box (owner 2026-10-15): the home's themes box for this one theme, as the themes page's expander shows
     it, in the page itself; the page follows the platform it shows (reviews, store sku). -->
<h1 class="sr-only" *ngIf="product">{{ product.name }} Theme</h1>
<app-theme-expander *ngIf="product"
                    [inline]="true"
                    [product]="product"
                    [category]="category"
                    [selectedPlatformFilter]="platformParam"
                    (platformChange)="onBoxPlatform( $event )"></app-theme-expander>

<!-- Palette detail: palette-tool section design (Color Palette / Platforms /
     channels / harmony / color vision / from the blog) driven by the theme.
     Platform previews render as their own "Platforms" section after the palette. -->
<app-color-detail *ngIf="paletteHexes.length > 0 || product?.isBundle" [boxes]="true"
                  [colors]="paletteHexes"
                  [colorNames]="paletteColorNames"
                  [overviewLabel]="'Theme'"
                  [platformPreviews]="platformPreviews"
                  [platformThemeName]="product.name"
                  [pillCardBg]="product.designTokens?.windowBackground || ''"
                  [pillFg]="product.designTokens?.editorForeground || ''"
                  [pillEditorBg]="product.designTokens?.editorBackground || ''"
                  [pillAccent]="product.designTokens?.primaryColor || ''"
                  [pillTone]="product.appearance === 'Dark' ? '#000000' : '#ffffff'"
                  [paletteLink]="themePalette ? { product: product.key, category: category } : undefined"
                  [blogThemeKey]="product.key"
                  [reviewProductKey]="product.key"
                  [reviewSku]="selectedSku || ''"
                  [reviewPlatformName]="selectedPlatform?.name || ''"
                  [reviewCards]="reviewCards"
                  [reviewOtherCount]="reviewOtherCount"
                  [reviewAverage]="product.rating > 0 ? product.rating : 0"
                  [bundleMode]="!!product?.isBundle"
                  [reviewWritable]="!product?.isBundle"
                  [swatchColors]="bundleSwatch"
                  [includesLabel]="'This Bundle Includes'">
  <!-- Bundle: the individual themes this collection ships for the selected platform,
       the first section of the page (owner, 2026-10-04: On This Page + Reviews like a theme). -->
  <ng-container ngProjectAs="[cpIncludes]" *ngIf="product?.isBundle && bundleIncludedThemes.length > 0">
    <header class="cp-head">
    <h2 class="cp-h2" [style.border-color]="product.designTokens?.primaryColor">This Bundle Includes: {{ bundleStats.total }} Themes</h2>
    <p class="cp-section-lead">
      Every theme in the {{ selectedPlatform?.name }} listing: {{ bundleStats.nature }} inspired by nature and
      {{ bundleStats.cities }} by cities, {{ bundleStats.dark }} dark and {{ bundleStats.light }} light, with new ones joining over time
    </p>
    </header>
    <div class="cp-main">
    <div class="bundle-includes-grid">
      <!-- Same poster card as the themes page so the whole site shows one
           card design; clicking an included theme opens its theme page. -->
      <app-theme-card *ngFor="let theme of bundleIncludedThemes; trackBy: trackByThemeKey"
                      [product]="theme"
                      [category]="theme.category"
                      [ribbon]="isThemeFree(theme) ? {text: 'Free', theme: ''} : {text: 'Premium', theme: ''}">
      </app-theme-card>
    </div>
  </div>
  </ng-container>
</app-color-detail>
